import Blank from './Blank';
import Default from './Default';
import Auth from './Auth';

export default { Blank, Default, Auth };
